import React, { useEffect, useState, useTransition } from "react";
import LoaderComponent from "../../../../components/custom/CustomLoader";
import { FaPlus } from "react-icons/fa6";
import { LiaDesktopSolid } from "react-icons/lia";
import { CiMobile3 } from "react-icons/ci";
import { IoIosArrowRoundBack } from "react-icons/io";
import {
  deleteRateplan,
  fetchRateplanDetails,
  getRateplanPolicies,
  postRatePlanPolicy,
} from "../../../../services/newServices";
import { useSelector } from "react-redux";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { MdDeleteOutline } from "react-icons/md";

import { MdDelete } from "react-icons/md";
import { LiaEditSolid } from "react-icons/lia";
import styles from "../promotions/promotions.module.css";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import CustomButton from "../../../../components/custom/CustomButton";
import rp_desktop from "../../../../assets/img/images/rp_desktop.png";
import rp_mobile from "../../../../assets/img/images/rp_mobile.png";

const Rateplans = () => {
  const { selectedHotel } = useSelector((state) => state.hotels);
  const hotelId = selectedHotel?.id;
  const { t } = useTranslation();
  const [view, setView] = useState("list");
  const [selectedRateplan, setSelectedRateplan] = useState(null);
  const [rateplansLoading, setrateplansLoading] = useState(true);
  const [rateplansData, setRateplansData] = useState([]);
  const [uniqueRateplans, setUniqueRateplans] = useState([]);
  const [policyModalOpen, setPolicyModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [policies, setPolicies] = useState([]);
  const [deletePolicyOpen, setDeletePolicyOpen] = useState(false);
  const [deleteRatePlan, setDeleteRatePlan] = useState(false);
  const [isSuperPackage, setIsSuperPackage] = useState();
  const [superPackageModal, setShowSuperPackageModal] = useState(false);
  const [buttonLoading, setbuttonLoading] = useState(false);
  const [deletePolicyIndex, setDeletePolicyIndex] = useState(null);
  const [deleteResultIndex, setDeleteResultIndex] = useState(null);
  const [isEditPolicy, setIsEditPolicy] = useState(false);
  const [selectedPolicy, setSelectedPolicy] = useState(null);
  const [newPolicy, setNewPolicy] = useState({
    Days_Before: "",
    Penalty_Value: "",
  });

  useEffect(() => {
   
  }, [selectedHotel]);

  useEffect(() => {
    if (hotelId) {
      fetchRateplans(hotelId);
    } else {
      console.error("Hotel ID is undefined.");
    }
  }, [hotelId]);

  const fetchRateplans = async (hotelId) => {
    setrateplansLoading(true);
    try {
      const response = await getRateplanPolicies({ hotelId });
      if (response.status === 200 && response.data) {
        const parsedData = response.data.map((rateplan) => ({
          ...rateplan,
          rate_plan_config: JSON.parse(rateplan.rate_plan_config),
        }));
        const uniquePlans = filterUniqueRateplans(parsedData);
        setRateplansData(parsedData);
        setUniqueRateplans(uniquePlans);
      }
    } catch (error) {
      console.error("Error fetching rateplans:", error);
    } finally {
      setrateplansLoading(false);
    }
  };
  const filterUniqueRateplans = (rateplans) => {
    const seenCodes = new Set();
    return rateplans.filter((rateplan) => {
      const isDuplicate = seenCodes.has(rateplan.rate_plan_code);
      seenCodes.add(rateplan.rate_plan_code);
      return !isDuplicate;
    });
  };

  const fetchRateplanDetailsById = async (ratePlan, showLoader = true) => {
    if (showLoader) {
      setrateplansLoading(true);
    }

    try {
      if (!ratePlan?.id) {
        console.error("ratePlanId is required to fetch details");
        return null;
      }
      const requestBody = { ratePlanId: ratePlan.id };

      const response = await fetchRateplanDetails(requestBody);

      if (response.status === 200 && response.data) {
       
        return response.data;
      } else {
        console.error("Failed to fetch rateplan details:", response);
      }
    } catch (error) {
      console.error("Error fetching rateplan details:", error);
    } finally {
      if (showLoader) {
        setrateplansLoading(false);
      }
    }
    return null;
  };

  const handleEdit = async (ratePlan) => {
    const detailedRateplan = await fetchRateplanDetailsById(ratePlan);

    if (detailedRateplan) {
      const parsedConfig = JSON.parse(detailedRateplan.rate_plan_config);
      setSelectedRateplan({
        ...detailedRateplan,
        rate_plan_config: parsedConfig,
      });

      setView("edit");
    }
  };
  
  const handleDeleteRateplanmodel = async (rateplan) => {
    setDeleteRatePlan(true);
    const detailedRateplan = await fetchRateplanDetailsById(rateplan, false);


    if (detailedRateplan) {
      const parsedConfig = JSON.parse(detailedRateplan.rate_plan_config);
      setSelectedRateplan({
        ...detailedRateplan,
        rate_plan_config: parsedConfig,
      });
    }
  };

  const handleAddNewPolicy = () => {
    setPolicyModalOpen(true);
  };
  const closeModal = () => {
    setPolicyModalOpen(false);
    setNewPolicy({
      Days_Before: "",
      Penalty_Value: "",
    });
    setDeletePolicyIndex(null);
    setDeleteResultIndex(null);
    setIsEditPolicy(false);
  };
  // const handleToggleChange = async () => {
  //   const updatedIsSuperPackage = !isSuperPackage;
  //   setIsSuperPackage(updatedIsSuperPackage);
  // };

  const handleToggleChange = async () => {
    // Toggle the current value
    const updatedIsSuperPackage =
      !selectedRateplan?.rate_plan_config?.packages?.isSuperPackage;

    // Update the selected rate plan state
    setSelectedRateplan((prev) => ({
      ...prev,
      rate_plan_config: {
        ...prev.rate_plan_config,
        packages: {
          ...prev.rate_plan_config.packages,
          isSuperPackage: updatedIsSuperPackage,
        },
      },
    }));
  };

  const handleSavePolicy1 = async () => {
    // Create the new policy object
    const newPolicyResult = {
      Days_Before: Number(newPolicy.Days_Before),
      Penalty_Value: String(newPolicy.Penalty_Value),
      Penalty_Type: "percent",
      Time_Before_Check_In: Number(newPolicy.Days_Before),
      Time_Before_Check_In_Type: "days",
    };

    // Update state first
    setSelectedRateplan((prev) => {
      const updatedPolicies = prev.rate_plan_config.policies || [];

      if (updatedPolicies.length === 0) {
        return {
          ...prev,
          rate_plan_config: {
            ...prev.rate_plan_config,
            policies: [
              {
                id: Date.now(),
                type: "cancellation",
                name: "cancellations",
                result: [newPolicyResult],
                condition: {
                  conditoin_value: "condition_key",
                },
              },
            ],
          },
        };
      } else {
        const updatedPolicy = { ...updatedPolicies[0] };
        updatedPolicy.result = [...updatedPolicy.result, newPolicyResult];

        return {
          ...prev,
          rate_plan_config: {
            ...prev.rate_plan_config,
            policies: [updatedPolicy],
          },
        };
      }
    });

    // Format data for API call
    const formattedData = {
      id: selectedRateplan.id,
      name: selectedRateplan.rate_plan_config.name,
      packages: selectedRateplan.rate_plan_config.packages || {},
      cancellationPolicy: {
        id: selectedRateplan.rate_plan_config.policies?.[0]?.id || Date.now(),
        type: "cancellation",
        name: "cancellations",
        result: [
          ...(selectedRateplan.rate_plan_config.policies?.[0]?.result || []),
          newPolicyResult,
        ],
        condition: {
          conditoin_value: "condition_key",
        },
      },
    };

    // Make the API call
    try {
      const response = await postRatePlanPolicy(formattedData);

      if (response.status === 200) {
        toast.success("Policy saved and updated successfully!");
      } else {
        toast.error("Failed to save policy.");
      }
    } catch (error) {
      console.error("Error saving policy:", error);
      toast.error("An error occurred while saving the policy.");
    }

    // Clear form and close modal
    setNewPolicy({ Days_Before: "", Penalty_Value: "" });
    setPolicyModalOpen(false);
  };

  const handleSavePolicy = async () => {
    // Create the new policy object
    const newPolicyResult = {
      Days_Before: Number(newPolicy.Days_Before),
      Penalty_Value: String(newPolicy.Penalty_Value),
      Penalty_Type: "percent",
      Time_Before_Check_In: Number(newPolicy.Days_Before),
      Time_Before_Check_In_Type: "days",
    };
    // if (
    //   newPolicyResult?.Penalty_Value === "" ||
    //   newPolicyResult?.Penalty_Value == null ||
    //   isNaN(newPolicyResult?.Penalty_Value) ||
    //   newPolicyResult?.Days_Before === "" ||
    //   newPolicyResult?.Days_Before == null ||
    //   isNaN(newPolicyResult?.Days_Before)
    // ) {
    //   toast.error("Please enter the details");
    //   return;
    // }

    if (newPolicyResult?.Days_Before != 0 && !newPolicyResult?.Days_Before) {
      toast.error("Please enter days before checkin");
      return;
    }

    if (newPolicyResult?.Penalty_Value > 100) {
      toast.error("penalty value must be less than or equal to 100");
      return;
    }
    if (
      newPolicyResult?.Penalty_Value < 0 ||
      1 / newPolicyResult?.Penalty_Value === -Infinity
    ) {
      
      toast.error("penalty value must be greater than or equal to 0");
      return;
    }
    if (
      newPolicyResult?.Days_Before < 0 ||
      1 / newPolicyResult.Days_Before === -Infinity
    ) {
      toast.error("Days before must be greater than or equal to 0");
      return;
    }

    // Compute updated policies
    const updatedPolicies = (() => {
      const currentPolicies =
        selectedRateplan?.rate_plan_config?.policies || [];
      const cancellationPolicy = currentPolicies.find(
        (policy) => policy.type === "cancellation"
      );
      if (!cancellationPolicy) {
        // If no policies exist, create the initial policy
        return [
          {
            id: Date.now(),
            type: "cancellation",
            name: "cancellations",
            result: [newPolicyResult],
            condition: {
              conditoin_value: "condition_key",
            },
          },
        ];
      } else {
        // Update existing policies
        const updatedPolicy = { ...cancellationPolicy };
        updatedPolicy.result = [
          ...(updatedPolicy.result || []),
          newPolicyResult,
        ];
        return [updatedPolicy];
      }
    })();

    // Update state with the updated policies
    setSelectedRateplan((prev) => ({
      ...prev,
      rate_plan_config: {
        ...prev.rate_plan_config,
        policies: updatedPolicies,
      },
    }));

    // Format data for API call
    const formattedData = {
      id: selectedRateplan.id,
      hotelId: selectedRateplan.hotel_id,
      ratePlanId: selectedRateplan.rate_plan_id,
      name: selectedRateplan.rate_plan_config.name,
      packages: selectedRateplan.rate_plan_config.packages || {},
      cancellationPolicy: updatedPolicies[0], // Use the updated policies
    };

    // Make the API call
    try {
      const response = await postRatePlanPolicy(formattedData);

      if (response.status === 200) {
        toast.success("Policy saved and updated successfully!");
      } else {
        toast.error("Failed to save policy.");
        return;
      }
    } catch (error) {
      console.error("Error saving policy:", error);
      toast.error("An error occurred while saving the policy.");
    }

    // Clear form and close modal
    setNewPolicy({ Days_Before: "", Penalty_Value: "" });
    setPolicyModalOpen(false);
  };

  // const handleUpdatePolicy = () => {
  //   // Logic to update the existing policy
  //   const updatedPolicies = [...selectedRateplan.rate_plan_config.policies];
  //   updatedPolicies[deletePolicyIndex].result[deleteResultIndex] = newPolicy;
  //   setSelectedRateplan((prev) => ({
  //     ...prev,
  //     rate_plan_config: {
  //       ...prev.rate_plan_config,
  //       policies: updatedPolicies,
  //     },
  //   }));
  //   closeModal(); // Close the modal after updating
  // };

  const handleUpdatePolicy1 = () => {
    if (deletePolicyIndex === null) {
      console.error("Policy index is not set");
      return;
    }

    // Copy the policies array
    const updatedPolicies = [...selectedRateplan.rate_plan_config.policies];

    // Find the policy to be updated by its index
    const updatedPolicy = { ...updatedPolicies[deletePolicyIndex] };

    // Ensure result is an array before calling map
    const updatedResult = updatedPolicy.result || [];

    // Update the specific result for this policy
    updatedPolicy.result = updatedResult.map((policyResult, index) =>
      index === deleteResultIndex
        ? { ...policyResult, ...newPolicy }
        : policyResult
    );

    // Apply the updated policy
    updatedPolicies[deletePolicyIndex] = updatedPolicy;

    // Set the updated policies in the state
    setSelectedRateplan((prev) => ({
      ...prev,
      rate_plan_config: {
        ...prev.rate_plan_config,
        policies: updatedPolicies,
      },
    }));

    // Close the modal
    closeModal();
  };

  // test
  const handleUpdatePolicy = async () => {
    
    if (deletePolicyIndex === null || deleteResultIndex === null) {
      console.error("Policy index or result index is not set");
      return;
    }

    if (newPolicy?.Penalty_Value != 0 && !newPolicy.Penalty_Value) {
      toast.error("Please enter penalty value");
      return;
    }
    if (newPolicy?.Days_Before != 0 && !newPolicy?.Days_Before) {
      toast.error("Please enter days before checkin");
      return;
    }

    if (newPolicy.Penalty_Value > 100) {
      toast.error("Penalty Value cannot be greater than 100!");
      return;
    }
    if (
      newPolicy.Penalty_Value < 0 ||
      1 / newPolicy.Penalty_Value === -Infinity
    ) {
    
      toast.error("Penalty Value cannot be less than 0!");
      return;
    }
    if (newPolicy.Days_Before < 0 || 1 / newPolicy.Days_Before === -Infinity) {
      toast.error("Days before cannot be less than 0!");
      return;
    }
    // Copy the policies array
    const updatedPolicies = [...selectedRateplan.rate_plan_config.policies];

    const updatedPolicy = updatedPolicies[deletePolicyIndex];
    if (!updatedPolicy) {
      console.error(`Policy not found at index ${deletePolicyIndex}`);
      return;
    }

    const updatedResult = updatedPolicy.result || [];
    if (updatedResult.length === 0) {
      console.error(`No result found for policy at index ${deletePolicyIndex}`);
      return;
    }

    updatedPolicy.result = updatedResult?.map((policyResult, index) =>
      index === deleteResultIndex
        ? { ...policyResult, ...newPolicy } // Update the policy result
        : policyResult
    );

    updatedPolicies[deletePolicyIndex] = updatedPolicy;

    // Update the selected rate plan with updated policies
    setSelectedRateplan((prev) => ({
      ...prev,
      rate_plan_config: {
        ...prev.rate_plan_config,
        policies: updatedPolicies,
      },
    }));

    const formattedData = {
      id: selectedRateplan.id,
      hotelId: selectedRateplan.hotel_id,
      ratePlanId: selectedRateplan.rate_plan_id,
      name: selectedRateplan.rate_plan_config.name,
      packages: selectedRateplan.rate_plan_config.packages || {},
      cancellationPolicy: updatedPolicies[deletePolicyIndex], // Use updated policies
    };

    try {
      const response = await postRatePlanPolicy(formattedData);

      if (response.status === 200) {
        toast.success("Policy updated successfully!");
      } else {
        toast.error("Failed to update policy.");
        return;
      }
    } catch (error) {
      console.error("Error updating policy:", error);
      toast.error("An error occurred while updating the policy.");
    }

    closeModal();
  };

  const handleDeletePolicy = async (policyIndex, resultIndex) => {
    if (!selectedRateplan) {
      console.error("No rate plan selected for policy deletion.");
      return;
    }

    const policyId = selectedRateplan?.id;
    if (!policyId) {
      console.error("Policy ID is required for deletion.");
      return;
    }

    // Copy the current policies for modification and rollback
    const originalPolicies = [...selectedRateplan.rate_plan_config.policies];
    const updatedPolicies = [...originalPolicies];

    // Remove the specific result
    updatedPolicies[policyIndex].result = updatedPolicies[
      policyIndex
    ].result.filter((_, i) => i !== resultIndex);

    // Update the state optimistically
    setSelectedRateplan((prev) => ({
      ...prev,
      rate_plan_config: {
        ...prev.rate_plan_config,
        policies: updatedPolicies,
      },
    }));

    // Prepare the payload for the API call
    const formattedData = {
      id: selectedRateplan.id,
      name: selectedRateplan.rate_plan_config.name,
      packages: selectedRateplan.rate_plan_config.packages || {},
      cancellationPolicy: updatedPolicies[policyIndex],
    };

    try {
      // Make the API call
      const response = await postRatePlanPolicy(formattedData);

      if (response.status === 200) {
        
        toast.success("policy deleted successfully");
        setDeletePolicyOpen(false);
      } else {
        console.error("Error updating policies.");

        // Rollback state in case of failure
        setSelectedRateplan((prev) => ({
          ...prev,
          rate_plan_config: {
            ...prev.rate_plan_config,
            policies: originalPolicies,
          },
        }));
      }
    } catch (error) {
      console.error("Error deleting policy:", error);
      toast.error("something went wrong");

      // Rollback state in case of error
      setSelectedRateplan((prev) => ({
        ...prev,
        rate_plan_config: {
          ...prev.rate_plan_config,
          policies: originalPolicies,
        },
      }));
    } finally {
      setDeletePolicyOpen(false);
    }
  };

  const handleRateplanUpdate = async () => {
   
    setIsSubmitting(true);
    try {
      // Format the data according to API structure
      const formattedData = {
        id: selectedRateplan.id,
        name: selectedRateplan.rate_plan_config.name,
        description: selectedRateplan.rate_plan_config.description || "",
        packages: selectedRateplan.rate_plan_config.packages || {},
        isSuperPackage: isSuperPackage,
        cancellationPolicy: {
          id: selectedRateplan.rate_plan_config.policies?.[0]?.id || Date.now(),
          type: "cancellation",
          name: "cancellations",
          result:
            selectedRateplan.rate_plan_config.policies
              ?.filter((policy) => policy.type === "cancellation")[0]
              ?.result?.map((result) => ({
                Days_Before: Number(result.Days_Before),
                Penalty_Type: "percent",
                Penalty_Value: String(result.Penalty_Value),
                Time_Before_Check_In: Number(result.Days_Before),
                Time_Before_Check_In_Type: "days",
              })) || [],
          condition: {
            conditoin_value: "condition_key",
          },
        },
      };

      const response = await postRatePlanPolicy(formattedData);

      if (response.status === 200) {
        toast.success("Rateplan updated successfully");
        if (isSuperPackage) {
          fetchRateplans(hotelId);
          setView("list");
          // setShowSuperPackageModal(true); // Open the super package modal
        } else {
          fetchRateplans(hotelId);
          setView("list");
        }
      } else {
        toast.error("Failed to update rateplan");
      }
    } catch (error) {
      console.error("Error updating rateplan:", error);
      toast.error("Failed to update rateplan");
    } finally {
      setIsSubmitting(false);
    }
  };

  // const handleDeleteRatePlan = async (ratePlanId) => {
  //   // Remove the rate plan with the specified ID from the state
  //   console.log("id", ratePlanId);
  //   const updatedRatePlans = rateplansData.filter(
  //     (ratePlan) => ratePlan.id !== ratePlanId
  //   );
  //   console.log("req", updatedRatePlans);
  //   setRateplansData(updatedRatePlans);

  //   // Send the updated array to the API to update on the server
  //   try {
  //     // setLoading(true);

  //     const requestBody = { ratePlanId: ratePlanId };
  //     console.log("rbody", requestBody);
  //     const response = await deleteRateplan(requestBody);

  //     if (response.status === 200) {
  //       // Successfully updated on the server
  //       console.log("Rate plans deleted successfully");
  //     } else {
  //       console.error("Error updating rate plans:");
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //   } finally {
  //     setDeleteRatePlan(false);
  //   }
  // };

  // const handleDeleteRatePlan = async (ratePlanId) => {
  //   try {
  //     console.log("Rate Plan ID to delete:", ratePlanId);
  //     const response = await deleteRateplan({ rateplanID: ratePlanId });

  //     if (response.status === 200) {
  //       console.log("Rate plans deleted successfully");
  //       const updatedRatePlans = rateplansData.filter(
  //         (ratePlan) => ratePlan.id !== ratePlanId
  //       );
  //       console.log("upda", updatedRatePlans);
  //       setRateplansData(updatedRatePlans);
  //     } else {
  //       console.error("Error deleting rate plans:", response?.statusText);
  //     }
  //   } catch (error) {
  //     console.error("Error in handleDeleteRatePlan:", error);
  //   } finally {
  //     setDeleteRatePlan(false);
  //   }
  // };

  const handleDeleteRatePlan = async (ratePlanId) => {
    try {
     

      // Call the delete API
      const response = await deleteRateplan({ rateplanID: ratePlanId });

      if (response.status === 200) {
      

        await fetchRateplans(hotelId);
      } else {
        console.error("Error deleting rate plan:", response?.statusText);
      }
    } catch (error) {
      console.error("Error in handleDeleteRatePlan:", error);
    } finally {
      setDeleteRatePlan(false);
    }
  };

  return (
    <div>
      {rateplansLoading ? (
        <LoaderComponent isLoading={true} />
      ) : (
        <>
          <Card>
            <CardHeader></CardHeader>
            <CardBody>
              {view === "list" ? (
                <>
                  <div>
                    <p
                      style={{
                        color: "#000",
                        leadingTrim: "both",
                        textEdge: "cap",
                        fontFamily: "Manrope",
                        fontSize: "24px",
                        fontStyle: "normal",
                        fontWeight: "600",
                        lineHeight: "normal",
                      }}
                    >
                      Rate plans
                    </p>
                    {uniqueRateplans?.length > 0 ? (
                      <p
                        style={{
                          color: "var(--Grey, #494545)",
                          leadingTrim: "both",
                          textEdge: "cap",
                          fontFamily: "Manrope",
                          fontSize: "16px",
                          fontStyle: "normal",
                          fontWeight: "400",
                          lineHeight: "normal",
                        }}
                      >
                        You have {uniqueRateplans?.length} rate plans for{" "}
                        {selectedHotel?.name}{" "}
                      </p>
                    ) : null}
                  </div>
                  <Modal
                    isOpen={deleteRatePlan}
                    toggle={() => setDeleteRatePlan(false)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "100px 0",
                    }}
                  >
                    <ModalHeader
                      toggle={() => setDeleteRatePlan(false)}
                      style={{ background: "none" }}
                    ></ModalHeader>
                    <ModalBody>
                      <p
                        style={{
                          color: "var(--Dark, #171719)",
                          fontFamily: "Plus Jakarta Sans",
                          fontSize: "20px",
                          fontStyle: "normal",
                          fontWeight: "600",
                          lineHeight: "24px",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        Are you sure you want to delete this Rateplan?
                      </p>
                    </ModalBody>
                    <ModalFooter
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "10px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          gap: "20px",
                        }}
                      >
                        <CustomButton
                          onClick={() =>
                            handleDeleteRatePlan(selectedRateplan?.id)
                          }
                          buttonStyle={{
                            background: "red",
                            color: "white",
                            padding: "8px 30px",
                          }}
                        >
                          Delete
                        </CustomButton>
                        <CustomButton
                          onClick={() => setDeleteRatePlan(false)}
                          buttonStyle={{
                            background: "white",
                            color: "black",
                            padding: "8px 30px",
                            border: "1px solid var(--Stroke, #D7D2D2)",
                          }}
                        >
                          Cancel
                        </CustomButton>
                      </div>
                    </ModalFooter>
                  </Modal>
                  {uniqueRateplans?.length > 0 ? (
                    <table
                      className="table table-bordered"
                      style={{
                        borderRadius: "10px",
                        borderCollapse: "separate", // Ensure this works without !important
                        borderSpacing: "0", // Remove gaps between table cells
                        overflow: "hidden", // Clip contents to the border radius
                      }}
                    >
                      <thead
                        className={styles.th}
                        style={{
                          color: "#5A5A5F",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontStyle: "normal",
                          fontWeight: "400",
                          lineHeight: "24px",
                        }}
                      >
                        <tr>
                          <th style={{ borderTopLeftRadius: "10px" }}>Name</th>
                          <th>Description</th>
                          <th style={{ borderTopRightRadius: "10px" }}>
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {uniqueRateplans.map((rateplan) => (
                          <tr key={rateplan.id} className="text-center">
                            <td>{rateplan.rate_plan_code}</td>
                            <td>
                              {rateplan.rate_plan_config.description ? (
                                <>{rateplan.rate_plan_config.description}</>
                              ) : (
                                <p
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  --
                                </p>
                              )}
                            </td>
                            <td
                              style={{
                                display: "flex",
                                justifyContent: "space-around",
                              }}
                            >
                              <LiaEditSolid
                                onClick={() => handleEdit(rateplan)}
                                style={{
                                  cursor: "pointer",
                                  fontSize: "1.5rem",
                                }}
                              />
                              <MdDeleteOutline
                                onClick={() =>
                                  handleDeleteRateplanmodel(rateplan)
                                }
                                style={{
                                  cursor: "pointer",
                                  fontSize: "1.5rem",
                                  color: "red",
                                }}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <p>No rateplans available for this property.</p>
                  )}
                </>
              ) : view === "edit" && selectedRateplan ? (
                <div>
                  <p onClick={() => setView("list")}>
                    {" "}
                    <IoIosArrowRoundBack size={30} />
                    Go back
                  </p>
                  <p
                    style={{
                      color: "#000",
                      leadingTrim: "both",
                      textEdge: "cap",
                      fontFamily: "Manrope",
                      fontSize: "20px",
                      fontStyle: "normal",
                      fontWeight: "600",
                      lineHeight: "normal",
                    }}
                  >
                    Edit your rateplan
                  </p>
                  <p
                    style={{
                      color: "var(--Grey, #494545)",
                      leadingTrim: "both",
                      textEdge: "cap",
                      fontfamily: "Manrope",
                      fontSize: "15px",
                      fontStyle: "normal",
                      fontWeight: "400",
                      lineHeight: "normal",
                    }}
                  >
                    Enter the details you want to change
                  </p>
                  <form>
                    <Label
                      for="name"
                      style={{
                        color: "var(--Neutral-neutral-100, #141519)",
                        fontFamily: "Plus Jakarta Sans",
                        fontSize: "20px",
                        fontStyle: "normal",
                        fontWeight: "500",
                        lineHeight: "24px",
                        marginBottom: "12px",
                      }}
                    >
                      Rateplan name
                    </Label>
                    <Input
                      type="text"
                      name="name"
                      id="name"
                      value={selectedRateplan.rate_plan_config.name || ""}
                      onChange={(e) => {
                        const newValue = e.target.value; // Capture the value immediately
                        setSelectedRateplan((prev) => ({
                          ...prev,
                          rate_plan_config: {
                            ...prev.rate_plan_config,
                            name: newValue,
                          },
                        }));
                      }}
                      style={{ width: "50%" }}
                    ></Input>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        margin: "15px 0",
                        alignItems: "center",
                      }}
                    >
                      <p
                        style={{
                          color: "var(--Neutral-neutral-100, #141519)",
                          fontFamily: "Plus Jakarta Sans",
                          fontSize: "20px",
                          fontStyle: "normal",
                          fontWeight: "500",
                          lineHeight: "24px",
                        }}
                      >
                        Cancellation Policy
                      </p>
                      <p
                        onClick={() => handleAddNewPolicy()}
                        style={{
                          borderRadius: "4px",
                          border: "1px solid var(--Dark, #171719)",
                          padding: "10px",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          cursor: "pointer",
                        }}
                      >
                        <FaPlus size={15} />
                        <span
                          style={{
                            color: "var(--Dark, #171719)",
                            textAlign: "center",
                            fontFamily: "Plus Jakarta Sans",
                            fontSize: "14px",
                            fontStyle: "normal",
                            fontWeight: "400",
                          }}
                        >
                          New policy
                        </span>
                      </p>
                    </div>

                    <Modal
                      isOpen={policyModalOpen}
                      toggle={closeModal}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "100px 0",
                      }}
                    >
                      <ModalHeader
                        toggle={closeModal}
                        style={{ background: "none" }}
                      ></ModalHeader>
                      <ModalBody>
                        <p
                          style={{
                            color: "var(--Dark, #171719)",
                            fontFamily: "Plus Jakarta Sans",
                            fontSize: "24px",
                            fontStyle: "normal",
                            fontWeight: "600",
                            lineHeight: "24px",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          Cancellation Policy
                        </p>
                        <Label
                          for="heading"
                          style={{
                            color: "var(--Neutral-neutral-100, #141519)",
                            fontFamily: "Plus Jakarta Sans",
                            fontSize: "15px",
                            fontStyle: "normal",
                            fontWeight: "400",
                            lineHeight: "24px",
                          }}
                        >
                          How much % of the booking amount is the guest charged
                          for cancellation{" "}
                        </Label>
                        <Input
                          type="number"
                          name="percentCharge"
                          id="percentCharge"
                          placeholder="Enter here"
                          value={newPolicy.Penalty_Value}
                          onChange={(e) => {
                            const value = e.target.value;
                            setNewPolicy((prev) => ({
                              ...prev,
                              Penalty_Value: value,
                            }));
                          }}
                        ></Input>
                        <Label
                          for="heading"
                          style={{
                            color: "var(--Neutral-neutral-100, #141519)",
                            fontFamily: "Plus Jakarta Sans",
                            fontSize: "15px",
                            fontStyle: "normal",
                            fontWeight: "400",
                            lineHeight: "24px",
                          }}
                        >
                          Days before arrival
                        </Label>
                        <Input
                          type="number"
                          name="days"
                          id="days"
                          placeholder="Enter here"
                          value={newPolicy.Days_Before}
                          onChange={(e) => {
                            const value = e.target.value;
                            setNewPolicy((prev) => ({
                              ...prev,
                              Days_Before: value,
                            }));
                          }}
                        ></Input>
                      </ModalBody>
                      <ModalFooter
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          gap: "10px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: "20px",
                          }}
                        >
                          <CustomButton
                            onClick={
                              isEditPolicy
                                ? handleUpdatePolicy
                                : handleSavePolicy
                            }
                            buttonStyle={{
                              background: "var(--Blue, #1764D1)",
                              color: "white",
                              padding: "8px 30px",
                            }}
                            disable={
                              isNaN(newPolicy.Penalty_Value) ||
                              newPolicy.Penalty_Value === "" ||
                              isNaN(newPolicy.Days_Before) ||
                              newPolicy.Days_Before === ""
                            }
                          >
                            Save
                          </CustomButton>
                          <CustomButton
                            onClick={closeModal}
                            buttonStyle={{
                              background: "white",
                              color: "black",
                              padding: "8px 30px",
                              border: "1px solid var(--Stroke, #D7D2D2)",
                            }}
                          >
                            Cancel
                          </CustomButton>
                        </div>
                      </ModalFooter>
                    </Modal>
                    {selectedRateplan?.rate_plan_config?.policies?.filter(
                      (policy) => policy.type === "cancellation"
                    )[0]?.result?.length > 0 ? (
                      <table
                        className="table table-bordered"
                        style={{
                          borderRadius: "10px",
                          borderCollapse: "separate",
                          borderSpacing: "0",
                          overflow: "hidden",
                        }}
                      >
                        <thead class={styles.th}>
                          <tr>
                            <th style={{ borderTopLeftRadius: "10px" }}>
                              Days Before Check-in
                            </th>
                            <th>Amount Charged (%)</th>
                            <th style={{ borderTopRightRadius: "10px" }}>
                              Actions
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {selectedRateplan.rate_plan_config.policies?.map(
                            (policy, policyIndex) =>
                              Array.isArray(policy?.result) &&
                              policy.result?.map((result, resultIndex) => (
                                <tr
                                  className="text-center"
                                  key={`${policy.id}-${resultIndex}`}
                                >
                                  <td className="text-center">
                                    {/* <Input
                                    type="number"
                                    value={result.Days_Before || ""}
                                    onChange={(e) => {
                                      const updatedPolicies = [
                                        ...selectedRateplan.rate_plan_config
                                          .policies,
                                      ];
                                      updatedPolicies[policyIndex].result[
                                        resultIndex
                                      ].Days_Before = e.target.value;
                                      setSelectedRateplan((prev) => ({
                                        ...prev,
                                        rate_plan_config: {
                                          ...prev.rate_plan_config,
                                          policies: updatedPolicies,
                                        },
                                      }));
                                    }}
                                  /> */}
                                    <Input
                                      type="number"
                                      value={
                                        result.Days_Before === 0
                                          ? 0
                                          : result.Days_Before || ""
                                      }
                                      readOnly
                                      style={{
                                        border: "none",
                                        background: "none",
                                        textAlign: "center",
                                      }}
                                      // onChange={(e) => {
                                      //   const updatedPolicies = [
                                      //     ...selectedRateplan.rate_plan_config
                                      //       .policies,
                                      //   ];
                                      //   updatedPolicies[policyIndex].result[
                                      //     resultIndex
                                      //   ].Days_Before = e.target.value;
                                      //   setSelectedRateplan((prev) => ({
                                      //     ...prev,
                                      //     rate_plan_config: {
                                      //       ...prev.rate_plan_config,
                                      //       policies: updatedPolicies,
                                      //     },
                                      //   }));
                                      // }}
                                    />
                                  </td>
                                  <td>
                                    <Input
                                      type="number"
                                      value={result.Penalty_Value || ""}
                                      readOnly
                                      style={{
                                        border: "none",
                                        background: "none",
                                        textAlign: "center",
                                      }}
                                      // onChange={(e) => {
                                      //   const updatedPolicies = [
                                      //     ...selectedRateplan.rate_plan_config
                                      //       .policies,
                                      //   ];
                                      //   updatedPolicies[policyIndex].result[
                                      //     resultIndex
                                      //   ].Penalty_Value = e.target.value;
                                      //   setSelectedRateplan((prev) => ({
                                      //     ...prev,
                                      //     rate_plan_config: {
                                      //       ...prev.rate_plan_config,
                                      //       policies: updatedPolicies,
                                      //     },
                                      //   }));
                                      // }}
                                    />
                                  </td>
                                  <td
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-around",
                                      alignItems: "center",
                                      borderBottom: "none",
                                    }}
                                  >
                                    <LiaEditSolid
                                      style={{
                                        cursor: "pointer",
                                        fontSize: "1.5rem",
                                      }}
                                      onClick={() => {
                                        // Find the correct policy index based on the current result being edited
                                        const policyIndex =
                                          selectedRateplan.rate_plan_config.policies.findIndex(
                                            (p) =>
                                              p.type === "cancellation" &&
                                              p.result.some((r) => r === result)
                                          );

                                        // Find the result index within that policy
                                        const resultIndex =
                                          selectedRateplan.rate_plan_config.policies[
                                            policyIndex
                                          ].result.findIndex(
                                            (r) => r === result
                                          );

                                        setDeletePolicyIndex(policyIndex);
                                        setDeleteResultIndex(resultIndex);
                                        setIsEditPolicy(true);
                                        setSelectedPolicy(result);
                                        setNewPolicy({
                                          Penalty_Value: result.Penalty_Value,
                                          Days_Before: result.Days_Before,
                                        });
                                        setPolicyModalOpen(true);
                                      }}
                                    />

                                    <MdDeleteOutline
                                      style={{
                                        cursor: "pointer",
                                        fontSize: "1.5rem",
                                        color: "red",
                                      }}
                                      onClick={() => {
                                        setDeletePolicyIndex(policyIndex);
                                        setDeleteResultIndex(resultIndex);
                                        setDeletePolicyOpen(true);
                                      }}
                                    />
                                  </td>
                                </tr>
                              ))
                          )}
                        </tbody>
                      </table>
                    ) : (
                      <p>
                        You do not have any cancellation policies available at
                        the moment, would you like to add one?
                      </p>
                    )}

                    <div style={{ display: "flex", flexDirection: "column" }}>
                      {" "}
                      <Label
                        for="name"
                        style={{
                          color: "var(--Neutral-neutral-100, #141519)",
                          fontFamily: "Plus Jakarta Sans",
                          fontSize: "20px",
                          fontStyle: "normal",
                          fontWeight: "500",
                          lineHeight: "24px",

                          marginBottom: "12px",
                        }}
                      >
                        Rateplan description
                      </Label>
                      <textarea
                        type="text"
                        name="name"
                        id="name"
                        value={
                          selectedRateplan.rate_plan_config.description || ""
                        }
                        onChange={(e) => {
                          const newValue = e.target.value; // Capture the value immediately
                          setSelectedRateplan((prev) => ({
                            ...prev,
                            rate_plan_config: {
                              ...prev.rate_plan_config,
                              description: newValue,
                            },
                          }));
                        }}
                        style={{
                          width: "60%",
                          border: "1px solid #ccc",
                          borderRadius: "5px",
                        }}
                        rows={5}
                      ></textarea>
                    </div>
                    {/* custom inclusions part of the code */}
                    {/* <div style={{ border: "5px solid black" }}>
                      <p
                        style={{
                          color: " var(--Dark, #171719)",
                          fontFamily: "Plus Jakarta Sans",
                          fontSize: "20px",
                          fontStyle: "normal",
                          fontWeight: "500",
                          lineHeight: "24px",
                        }}
                      >
                        Custom inclusions
                      </p>

                      <div>
                        <table
                          style={{
                            width: "100%",
                            borderSpacing: "0 10px",
                            borderCollapse: "separate",
                          }}
                        >
                          <tr>
                            <td
                              style={{ textAlign: "center", padding: "10px" }}
                            >
                              <Label for="select" style={{ display: "flex" }}>
                                Select Type
                              </Label>
                              <Input
                                type="select"
                                name="discountType"
                                id="discountType"
                              >
                                <option value="discount%">discount %</option>
                                <option value="discountfixed">
                                  discount fixed
                                </option>
                                <option value="free">free</option>
                              </Input>
                            </td>
                            <td
                              style={{ textAlign: "center", padding: "10px" }}
                            >
                              <Label
                                for="discountAmount"
                                style={{ display: "flex" }}
                              >
                                Enter Amount
                              </Label>
                              <Input
                                type="number"
                                name="discountAmount"
                                id="discountAmount"
                              ></Input>
                            </td>
                            <td
                              style={{ textAlign: "center", padding: "10px" }}
                            >
                              <Label
                                for="description"
                                style={{ display: "flex" }}
                              >
                                Description
                              </Label>
                              <Input
                                type="text"
                                name="description"
                                id="description"
                                placeholder="e.g. F&B Service"
                              ></Input>
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                padding: "40px 10px 0 0",
                                display: "flex",
                                justifyContent: "space-around",
                              }}
                            >
                              <p
                                style={{
                                  marginRight: "5px",
                                  textDecoration: "underline",
                                }}
                              >
                                Save
                              </p>
                              <p>Clear</p>
                            </td>
                          </tr>
                        </table>
                      </div>
                      <div style={{ margin: "10px 0 20px" }}>
                        <FaPlus size={20} />{" "}
                        <span
                          style={{
                            color: "var(--Grey, #494545)",
                            textAlign: "center",
                            fontFamily: "Plus Jakarta Sans",
                            fontSize: "16px",
                            fontstyle: "normal",
                            fontWeight: "600",
                            lineHeight: "24px",
                          }}
                        ></span>
                        Add more Custom inclusions
                      </div>

                      <div>
                        <table className="table table-bordered">
                          {" "}
                          <thead className={styles.tr}>
                            <tr>
                              <th
                                className={styles.th}
                                style={{ display: "flex" }}
                              >
                                Inclusions preview
                              </th>
                            </tr>
                          </thead>
                        </table>
                        <p>
                          Drag and reorder inclusions so it will be visible at
                          the first when guests search your hotel{" "}
                        </p>
                        <p>no inclusions to preview</p>
                      </div>
                    </div> */}
                  </form>

                  <div
                    style={{
                      display: "flex",
                      gap: "15px",
                      alignItems: "center",
                      marginTop: "30px",
                    }}
                  >
                    <input
                      type="checkbox"
                      id={1}
                      key={1}
                      checked={
                        selectedRateplan?.rate_plan_config?.packages
                          ?.isSuperPackage || false
                      }
                      onChange={handleToggleChange}
                      // checked={isTaxIncluded}
                      // onChange={handleToggleChange}
                      style={{ width: "20px", height: "24px" }}
                    />
                    <p
                      style={{
                        margin: 0,
                        color: "var(--Neutral-neutral-100, #141519)",
                        fontFamily: "Plus Jakarta Sans",
                        fontSize: "16px",
                        fontStyle: "normal",
                        fontWeight: "400",
                        lineHeight: "24px",
                      }}
                    >
                      Mark this rateplan as super package.{" "}
                      <a
                        onClick={() => setShowSuperPackageModal(true)}
                        style={{
                          color: "blue",
                          textDecoration: "underline",
                          marginLeft: "8px",
                        }}
                      >
                        Know More
                      </a>
                    </p>
                  </div>
                  <div style={{ marginTop: "50px " }}>
                    <CustomButton
                      buttonStyle={{
                        background: "var(--Blue, #1764D1)",
                        padding: "15px 40px",
                      }}
                      onClick={() => handleRateplanUpdate()}
                      disabled={isSubmitting}
                    >
                      <span
                        style={{
                          margin: 0,
                          fontFamily: "Plus Jakarta Sans",
                          fontSize: "16px",
                          fontStyle: "normal",
                          fontWeight: "400",
                          lineHeight: "24px",
                        }}
                      >
                        {isSubmitting ? "Saving..." : "Save"}
                      </span>
                    </CustomButton>
                  </div>

                  <Modal
                    isOpen={deletePolicyOpen}
                    toggle={closeModal}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "100px 0",
                    }}
                  >
                    <ModalHeader
                      toggle={() => {
                        setDeletePolicyOpen(false);
                      }}
                      style={{ background: "none" }}
                    ></ModalHeader>
                    <ModalBody>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        {" "}
                        <p
                          style={{
                            color: "var(--Dark, #171719)",
                            fontFamily: "Plus Jakarta Sans",
                            fontSize: "22px",
                            fontStyle: "normal",
                            fontWeight: "600",
                            lineHeight: "24px",
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <span
                            style={{
                              display: "inline-flex", // Ensures proper alignment and centering
                              justifyContent: "center", // Centers the icon horizontally
                              alignItems: "center", // Centers the icon vertically
                              background: "#FF5A54",
                              borderRadius: "50%",
                              padding: "10px",
                            }}
                          >
                            <MdDeleteOutline
                              size={20}
                              style={{
                                color: "white",
                              }}
                            />
                          </span>{" "}
                          Delete Cancellation Policy?
                        </p>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          margin: "0 30px",
                        }}
                      >
                        {" "}
                        <p
                          style={{
                            color: "var(--Grey, #494545)",
                            fontFamily: "Plus Jakarta Sans",
                            fontSize: "15px",
                            fontStyle: "normal",
                            fontWeight: "400",
                            lineHeight: "28px",
                          }}
                        >
                          Are you sure you want to delete this Cancellation
                          Policy?
                        </p>
                      </div>
                    </ModalBody>
                    <ModalFooter
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          gap: "20px",
                        }}
                      >
                        <CustomButton
                          buttonStyle={{
                            background: "white",
                            color: "var(--Grey, #494545)",
                            padding: "12px 40px",
                            border: "1px solid var(--Stroke, #D7D2D2)",

                            textSlign: "center",
                            fontFamily: "Plus Jakarta Sans",
                            fontsize: "22px",
                            fontStyle: "normal",
                            fontWeight: "500",
                            lineHeight: "24px",
                          }}
                          onClick={() => setDeletePolicyOpen(false)}
                        >
                          Cancel
                        </CustomButton>
                        <CustomButton
                          onClick={() =>
                            handleDeletePolicy(
                              deletePolicyIndex,
                              deleteResultIndex
                            )
                          }
                          loading={buttonLoading}
                          buttonStyle={{
                            background: "#FA5658",
                            color: "white",
                            padding: "12px 40px",
                            textSlign: "center",
                            fontFamily: "Plus Jakarta Sans",
                            fontsize: "22px",
                            fontStyle: "normal",
                            fontWeight: "500",
                            lineHeight: "24px",
                          }}
                        >
                          Delete
                        </CustomButton>
                      </div>
                    </ModalFooter>
                  </Modal>

                  <Modal
                    isOpen={superPackageModal}
                    toggle={() => setShowSuperPackageModal(false)}
                    centered // Centers the modal vertically on the page
                    style={{
                      maxWidth: "800px", // Set custom width
                      width: "90%", // Make it responsive to smaller screens
                      margin: "0 auto", // Centers horizontally
                    }}
                  >
                    <ModalHeader
                      toggle={() => setShowSuperPackageModal(false)}
                      style={{ background: "none" }}
                    ></ModalHeader>

                    <ModalBody>
                      <p
                        style={{
                          color: "var(--Grey, #494545)",
                          fontFamily: "Plus Jakarta Sans",
                          fontSize: "24px",
                          fontStyle: "normal",
                          fontWeight: "500",
                          lineHeight: "24px",
                          display: "flex",
                          justifyContent: "center",
                          marginBottom: "50px",
                        }}
                      >
                        {" "}
                        How do guests see Super Package on your website?
                      </p>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          gap: "50px", // Add spacing between the two sections
                        }}
                      >
                        <div style={{ textAlign: "center" }}>
                          <p
                            style={{
                              color: "var(--Grey, #494545)",
                              fontFamily: "Plus Jakarta Sans",
                              fontSize: "14px",
                              fontStyle: "normal",
                              fontweight: "400",
                              lineHeight: "24px",
                              display: "flex",
                              justifyContent: "center",
                              gap: "10px",
                              alignItems: "center",
                            }}
                          >
                            <span>
                              <LiaDesktopSolid size={20} />
                            </span>
                            Desktop view
                          </p>
                          <img
                            src={rp_desktop}
                            alt="Desktop View"
                            style={{
                              maxWidth: "100%",
                              height: "auto",
                              maxHeight: "200px", // Limit height to prevent overflow
                              // border: "1px solid #ccc",
                              // borderRadius: "8px",
                            }}
                          />
                          {/* <div style={{ marginTop: "10px" }}>
                            <p style={{ margin: 0 }}>Super Package</p>
                            <p style={{ margin: 0 }}>Rateplan Name</p>
                          </div> */}
                        </div>
                        <div style={{ textAlign: "center" }}>
                          <p
                            style={{
                              color: "var(--Grey, #494545)",
                              fontFamily: "Plus Jakarta Sans",
                              fontSize: "14px",
                              fontStyle: "normal",
                              fontweight: "400",
                              lineHeight: "24px",
                              display: "flex",
                              justifyContent: "center",
                              gap: "10px",
                              alignItems: "center",
                            }}
                          >
                            <span>
                              <CiMobile3 size={20} />
                            </span>
                            Mobile view
                          </p>
                          <img
                            src={rp_mobile}
                            alt="Mobile View"
                            style={{
                              maxWidth: "100%",
                              height: "auto",
                              maxHeight: "200px", // Limit height to prevent overflow
                              // border: "1px solid #ccc",
                              // borderRadius: "8px",
                            }}
                          />
                        </div>
                      </div>

                      {/* <p>
                        <strong>Rate Plan Name:</strong>{" "}
                        {selectedRateplan.rate_plan_config.name}
                      </p>
                      <p>
                        <strong>Policies:</strong>{" "}
                        {JSON.stringify(
                          selectedRateplan.rate_plan_config.policies
                        )}
                      </p> */}
                      {/* Add more details as needed */}
                    </ModalBody>
                  </Modal>
                </div>
              ) : (
                <p>No rateplans available for this property</p>
              )}
            </CardBody>
          </Card>
        </>
      )}
    </div>
  );
};

export default Rateplans;
